<template>
  <div class="ticket-page">
    <b-form-input
      v-model="filter.search"
      placeholder="ค้นหา Ticket"
      class="ticket-search"
      @keyup.enter="handleSearch({ search: filter.search })"
    />

    <div class="ticket-list">
      <b-card
        v-for="t in displayTickets"
        :key="t._key"
        class="ticket-card"
        body-class="p-0"
        @click="goDetail(t.raw)"
      >
        <div class="p-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="ticket-id">#{{ t.no }}</div>

            <div class="d-flex align-items-center ticket-time">
              <font-awesome-icon icon="clock" class="mr-2"></font-awesome-icon>
              <span>{{ t.timeText }}</span>
            </div>
          </div>

          <div class="mt-2">
            <b-badge pill class="status-pill" :class="statusClass(t)">
              {{ t.statusText }}
            </b-badge>
          </div>

          <div class="mt-2 ticket-title clamp-2">
            {{ t.title }}
          </div>
        </div>
      </b-card>

      <div
        v-if="!isBusy && displayTickets.length === 0"
        class="text-center text-muted py-4"
      >
        ไม่พบรายการ
      </div>

      <div v-if="isBusy" class="text-center text-muted py-3">
        <b-spinner small class="mr-2" /> กำลังโหลด...
      </div>
    </div>
  </div>
</template>

<script>
const moment = require("moment");

export default {
  data() {
    return {
      items: [],
      rows: 0,
      isBusy: false,
      filter: {
        type: [], // list int
        user_guids: [], // list string
        admin_user_guid: [], // list string
        source: [], // list string
        created_time_type: 4,
        last_updated_time_type: 4,
        status: [], // list int
        sla_status: [],
        search: "",
        search_member_id: "",
        search_name: "",
        search_tel_email: "",
        search_content: "",
        page: 1,
        take: 10,
        onlyMe: 0,
        sortColumnId: 0, // 1 = created_time, 2 = updated_time
        sortType: true, // true = ASC, false = DESC
        createdDateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"),
        createdDateTo: moment().format("YYYY-MM-DD"),
        lastUpdatedDateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"),
        lastUpdatedDateTo: moment().format("YYYY-MM-DD"), // Type DateTime
      },
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    displayTickets() {
      return (this.items || []).map((it, idx) => this.normalizeTicket(it, idx));
    },
  },

  methods: {
    normalizeTicket(it, idx) {
      const no =
        it.ticket_no || it.ticket_number || it.code || it.no || it.id || "-";

      const title = it.name || "-";

      const updated = it.created_time || it.created_at || null;

      const statusId =
        it.status_id ?? it.statusId ?? it.status ?? it.status_code ?? null;

      const statusText = this.getStatusText(statusId, it);

      const timeText = updated ? moment(updated).fromNow() : "-";

      const isNewDot = updated
        ? moment().diff(moment(updated), "minutes") <= 5
        : false;

      return {
        _key: `${no}-${updated || idx}`,
        no,
        title,
        timeText,
        statusText,
        isNewDot,
        raw: it,
      };
    },

    getStatusText(statusId, it) {
      // const s = (it.status || it.status_name || "").toString().toLowerCase();
      return it.status;
    },

    goDetail(row) {
      // this.$router.push("ticket/" + row.id);
      window.parent.postMessage(
        { type: "onOpenDetail", detail: row },
        this.$parentOrigin,
      );
      this.$router.push("ticket/" + row.id);
    },

    async getList() {
      this.isBusy = true;
      await this.fetchData();
      this.isBusy = false;
    },

    handleSearch(e) {
      this.filter = {
        ...this.filter,
        ...e,
        page: 1,
        pageSize: 10,
      };
      this.silentSetFilter && this.silentSetFilter({ page: 1 });
      this.getList();
    },

    async fetchData(isFetch = false) {
      let tempList = [...this.items];
      const payload = {
        ...this.filter,
        pageSize: this.filter.take,
        status: this.$route.query.status ? [this.$route.query.status] : [],
        user_guids: this.$route.query.user_guid
          ? [this.$route.query.user_guid]
          : [],
      };
      const { data } = await this.axios.post(`/ticket/get_list`, payload);

      if (data.result == 1 && data.detail.data) {
        if (isFetch) {
          const check = tempList.filter((el) => {
            if (data.detail?.data.findIndex((a) => a.id == el.id) == -1)
              return true;
            return false;
          });
          if (check.length > 0) {
            this.items = data.detail.data || [];
            this.rows = data.detail.total;

            this.$bvToast.toast(`${check.length} New Ticket `, {
              title: "You Have New Ticket",
              autoHideDelay: 5000,
              appendToast: false,
            });
          }
        } else {
          this.items = data.detail.data || [];
          this.rows = data.detail.total;
        }
      }
    },
    statusClass(t) {
      if (t.statusText === "Resolve") return "status-resolve";
      if (t.statusText === "In Progress") return "status-assign";
      if (t.statusText === "Close") return "status-close";
      return "status-open";
    },
  },
};
</script>

<style scoped>
.ticket-page {
  padding: 12px;
  height: 97vh;
  overflow: auto;
}

.ticket-search {
  border-radius: 4px;
  height: 44px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.ticket-list {
  margin-top: 12px;
}

.ticket-card {
  border-radius: 8px;
  border: 0;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  cursor: pointer;
}

.ticket-id {
  font-weight: 700;
  color: #2b2f38;
  font-size: 14px;
}

.ticket-time {
  color: #8a93a3;
  font-size: 12px;
  white-space: nowrap;
}

.active-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  display: inline-block;
}
.active-dot--green {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
}

.status-pill {
  font-size: 12px;
  padding: 6px 12px;
  font-weight: 600;
}

.status-open {
  background: rgba(45, 212, 191, 0.12);
  color: #14b8a6;
  border: 1px solid rgba(20, 184, 166, 0.35);
}

.status-close {
  background: rgba(148, 163, 184, 0.18);
  color: #94a3b8;
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.ticket-title {
  color: #3a4050;
  font-size: 14px;
  line-height: 1.35;
}

.clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.status-assign {
  border: 1px solid #ff9f43;
  color: #ff9f43;
  background: transparent;
}
.status-resolve {
  background: #27bda6;
  color: white;
  /* background: transparent; */
}
.status-open {
  border: 1px solid rgba(20, 184, 166, 0.35);
  background: rgba(45, 212, 191, 0.12);
  color: #14b8a6;
}

.status-close {
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(148, 163, 184, 0.18);
  color: #94a3b8;
}
</style>
